import { useState } from "react";
import { CoalitionSection } from "../CoalitionSection";
import { CoalitionModal } from "../CoalitionModal";
import { CoalitionCardAwards } from "../CoalitionCardAwards";
import { CoalitionCardAwardsDetail } from "..";
import { EmptyBlock } from "./EmptyBlock";
import { empty_awards } from "../../pngs";
import { toggleScrollLock, getCardDetail } from "../../utils";

export const AwardsBlock = ({ awards, balance }) => {
  const [modal, setModal] = useState(null);
  const [isShown, setIsShown] = useState(false);
  const [activeCard, setActiveCard] = useState(null);

  const toggleModal = (cardId = null) => {
    setIsShown(Boolean(cardId));
    toggleScrollLock();
    setActiveCard(getCardDetail(awards, cardId));
  };

  const title = "Premios disponibles";
  const emptyDesc =
    "Muy pronto podrás cambiar tus puntos por tus productos favoritos";
  const filledDesc = "Cambia tus puntos por productos de regalo";
  const modalTitle = "Todo sobre tu premio";

  return (
    <>
      {!awards || awards.length === 0 ? (
        <EmptyBlock
          title={title}
          description={emptyDesc}
          emptyState={empty_awards}
          isBlock={true}
        />
      ) : (
        <>
          <CoalitionSection title={title} subtitle={filledDesc}>
            {awards.map((i, k) => (
              <CoalitionCardAwards
                key={k}
                id={i.id}
                product={i.image}
                title={i.title}
                pointsRequired={i.pay_in_points}
                points={balance}
                showModal={(cardId) => toggleModal(cardId)}
              />
            ))}
          </CoalitionSection>
          {!isShown ? null : (
            <CoalitionModal
              modalRef={(n) => setModal(n)}
              closeModal={() => toggleModal()}
              onKeyDown={(e) => (e.keyCode === 27 ? toggleModal() : null)}
              onClickOutside={(e) =>
                modal && modal.contains(e.target) ? null : toggleModal()
              }
              title={modalTitle}
            >
              <CoalitionCardAwardsDetail card={activeCard} balance={balance} />
            </CoalitionModal>
          )}
        </>
      )}
    </>
  );
};
